<div class="d-flex justify-content-between align-center">
  <div>
    <strong>
      <span>Copyright &copy; {{ currentYear }}</span>
      <a
        [href]="brand.footerUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="m-0">
        {{ brand.footerLabel }}</a
      >
      <span>.</span>
    </strong>
    <span> All rights reserved.</span>

    <span class="ml-2 mr-2">
      <a
        style="text-decoration: underline"
        [href]="brand.privacyPolicyUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="m-0">
        Privacy policy
      </a>
    </span>
  </div>

  <div class="float-right d-none d-sm-block">
    <b>Version: </b>{{ currentAppVersion }}
  </div>
</div>
